import {
  Dashboard,
  SettingsPage,
  PropertiesPage,
  PropertyPage,
  ProductionPage,
  FieldsPage,
  DeviceManagementPage,
  AdminPage,
  HelpPage,
  PlansPage,
  EventsPage,
} from 'pages';

const appRoutes = [
  { path: '/production', component: ProductionPage, exact: true, strict: true },
  { path: '/settings/prefs', component: SettingsPage, exact: true, strict: true },
  { path: '/properties', component: PropertiesPage, exact: true, strict: true },
  { path: '/properties/update/:orgId', component: PropertyPage, strict: true },
  { path: '/properties/', component: PropertyPage, strict: true },
  { path: '/fields', component: FieldsPage, exact: true, strict: true },
  { path: '/admin', component: AdminPage, exact: true, strict: true },
  { path: '/help', component: HelpPage, exact: false, strict: false },
  { path: '/dashboard', component: Dashboard, exact: true, strict: true },
  { path: '/devices', component: DeviceManagementPage, strict: true },
  { path: '/plans', component: PlansPage, strict: true },
  { path: '/events', component: EventsPage, strict: true },
  { path: '/', component: Dashboard, exact: false, strict: false },
];

export default appRoutes;
